import type { SccrsGamingHall } from '@/entities/sccrs';

export const formatGamingHallRest = (hall: SccrsGamingHall) =>
  `${hall.gamingHallName}, ${hall.address}`;

export const formatGamingHallText = (hall: SccrsGamingHall) => {
  if (hall.displayName) {
    return `${hall.displayName}, ${formatGamingHallRest(hall)}`;
  }
  return formatGamingHallRest(hall);
};
